import { Component, OnInit } from '@angular/core';
import { Navigation } from 'src/app/enums/navigation.enum';

@Component({
    selector: 'app-navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.scss'],
    standalone: false
})
export class NavigationBarComponent implements OnInit {

  public isMenuCollapsed = true;
  linkRaces = '/'+Navigation.Races;
  linkEvents = '/'+Navigation.Events;
  linkEntries = '/'+Navigation.Entries;
  constructor() { }

  ngOnInit(): void {
  }

}
